export default __webpack_public_path__ + "d0eaedd92d6a0738079a194e1c2b76aa.mp3";